/* eslint-disable import/no-anonymous-default-export */
import React, { useEffect, useState } from "react";

import AlertNotice from "shared/AlertNotice";
import { Danger } from "react-ikonate";

import TopicsAdd from "./TopicsAdd";
import TopicsHistory from "./TopicsHistory";
import TopicDetails from "./TopicDetails";

import Loader from "shared/Loader";
import { useTopics } from "./useTopics";
import { last, set } from "lodash-es";

export default function ({ iboNumber, membership }) {
  const [iboA, setIboA] = useState(null);
  const [isAddingIboA, setIsAddingIboA] = useState(false);
  const [isDisplayingHistoryIboA, setIsDisplayingHistoryIboA] = useState(false);
  const [isDisplayingDetailsIboA, setIsDisplayingDetailsIboA] = useState(false);

  const [iboB, setIboB] = useState(null);
  const [isAddingIboB, setIsAddingIboB] = useState(false);
  const [isDisplayingHistoryIboB, setIsDisplayingHistoryIboB] = useState(false);
  const [isDisplayingDetailsIboB, setIsDisplayingDetailsIboB] = useState(false);

  const [userData, setUserData] = useState([]);

  const [accessCodeIboA, setAccessCodeIboA] = useState("");
  const [accessCodeIboB, setAccessCodeIboB] = useState("");

  const didRetrieveAccessCode = (accessCodeToDisplay, contactToUpdate) => {
    if (
      contactToUpdate &&
      contactToUpdate.wwgInfo &&
      contactToUpdate.wwgInfo.type &&
      contactToUpdate.wwgInfo.type === "IBO-A"
    ) {
      setAccessCodeIboA(accessCodeToDisplay);
    } else {
      setAccessCodeIboB(accessCodeToDisplay);
    }
  };

  const didRefetch = (contactToUpdate) => {
    if (
      contactToUpdate &&
      contactToUpdate.wwgInfo &&
      contactToUpdate.wwgInfo.type === "IBO-A"
    ) {
      setIboA(contactToUpdate);
      if (
        contactToUpdate &&
        contactToUpdate.topics &&
        contactToUpdate.topics.isComplete
      ) {
        setIsDisplayingHistoryIboA(false);
        setIsDisplayingDetailsIboA(true);
      }
    }

    if (
      contactToUpdate &&
      contactToUpdate.wwgInfo &&
      contactToUpdate.wwgInfo.type === "IBO-B"
    ) {
      setIboB(contactToUpdate);
    }
  };

  const didCreateTopicsAccount = (contactToAdd) => {
    if (contactToAdd && contactToAdd.type === "IBO-A") {
      let iboAToAdd = {
        wwgInfo: {
          iboNumber: contactToAdd.iboNumber,
          wwgId: contactToAdd.wwgId,
          firstName: contactToAdd.firstName,
          lastName: contactToAdd.lastName,
          email: contactToAdd.email,
          type: "IBO-A",
        },
        topics: null,
        actions: [],
        isComplete: false,
        isSyncing: true,
      };

      setIsAddingIboA(false);
      setIboA(iboAToAdd);
      setIsDisplayingHistoryIboA(true);
    }

    if (contactToAdd && contactToAdd.type === "IBO-B") {
      let iboBToAdd = {
        wwgInfo: {
          iboNumber: contactToAdd.iboNumber,
          wwgId: contactToAdd.wwgId,
          firstName: contactToAdd.firstName,
          lastName: contactToAdd.lastName,
          email: contactToAdd.email,
          type: "IBO-B",
        },
        topics: null,
        actions: [],
        isComplete: false,
        isSyncing: true,
      };

      setIsAddingIboB(false);
      setIboB(iboBToAdd);
      setIsDisplayingHistoryIboB(true);
    }
  };

  const didRetrieveGroupUsers = (groupUsers) => {
    setUserData(groupUsers);
  };

  const didRetrieveThreadUsers = (threadUsers) => {
    setUserData(threadUsers);
  };

  const {
    data,
    error,
    loading,

    addTopicsAccount,
    refetch,
    syncTopicsAccount,
    fetchIboSyncData,
    retrieveGroupUsers,
    retrieveThreadUsers,
    retrieveAccessCode,
  } = useTopics(
    iboNumber,
    didCreateTopicsAccount,
    didRefetch,
    didRetrieveGroupUsers,
    didRetrieveThreadUsers,
    didRetrieveAccessCode
  );

  const { cancelHistoryPut } = useTopics(iboNumber);

  const clearAccessCode = () => {
    setAccessCodeIboA("");
    setAccessCodeIboB("");
  };

  useEffect(() => {
    if (iboA && !iboA.topics && !iboA.isSyncing) {
      setIsAddingIboA(true);
    } else if (iboA && !iboA.topics && iboA.isSyncing) {
      setIsDisplayingHistoryIboA(true);
    } else if (iboA && iboA.topics) {
      setIsDisplayingDetailsIboA(true);
    }
  }, [iboA]);

  useEffect(() => {
    if (iboB && !iboB.topics && !iboB.isSyncing) {
      setIsAddingIboB(true);
    } else if (iboB && !iboB.topics && iboB.isSyncing) {
      setIsDisplayingHistoryIboB(true);
    } else if (iboB && iboB.topics) {
      setIsDisplayingDetailsIboB(true);
    }
  }, [iboB]);

  useEffect(() => {
    if (data?.iboA) {
      const formattedIboA = {
        ...data.iboA,
        topicsInfo: {
          ...data.iboA.topicsInfo,
          topicsId: String(data.iboA.topicsInfo?.topicsId ?? "").padStart(
            6,
            "0"
          ),
        },
      };
      setIboA(formattedIboA);
    }

    if (data?.iboB) {
      const formattedIboB = {
        ...data.iboB,
        topicsInfo: {
          ...data.iboB.topicsInfo,
          topicsId: String(data.iboB.topicsInfo?.topicsId ?? "").padStart(
            6,
            "0"
          ),
        },
      };
      setIboB(formattedIboB);
    }
  }, [data]);

  const handleCancel = (contact) => {
    cancelHistoryPut.mutate({
      iboNumber: contact.wwgInfo.iboNumber,
      wwgId: contact.wwgInfo.wwgId,
    });
  };

  return (
    <div>
      {data == null || loading ? (
        <Loader />
      ) : (
        <div>
          {iboA == null && (
            <AlertNotice icon={<Danger />} title="Error Encountered">
              <div>
                An error occurred retrieving Topics data. Please report this
                issue to QA.
              </div>
            </AlertNotice>
          )}

          {isAddingIboA && (
            <TopicsAdd
              data={iboA}
              onSubmit={async (contact) => {
                await addTopicsAccount(contact);
              }}
              membership={membership}
            />
          )}

          {isDisplayingHistoryIboA && (
            <TopicsHistory
              ibo={iboA}
              isCreatingIbo={iboA.isSyncing}
              isShowHistory={false}
              refresh={async (contact) => {
                await refetch(contact);
              }}
              onClose={() => {
                setIsDisplayingHistoryIboA(false);
              }}
              onCancel={handleCancel}
            ></TopicsHistory>
          )}

          {isDisplayingDetailsIboA && (
            <TopicDetails
              refetch={refetch}
              syncTopicsAccount={syncTopicsAccount}
              fetchIboSyncData={fetchIboSyncData}
              data={iboA}
              hideHeader={isDisplayingHistoryIboA}
              retrieveAccessCode={retrieveAccessCode}
              accessCode={accessCodeIboA}
              clearAccessCode={clearAccessCode}
              retrieveGroupUsers={retrieveGroupUsers}
              retrieveThreadUsers={retrieveThreadUsers}
              membership={membership}
              userData={userData}
            />
          )}

          {isAddingIboB && (
            <TopicsAdd
              data={iboB}
              onSubmit={async (contact) => {
                await addTopicsAccount(contact);
              }}
              membership={membership}
            />
          )}

          {isDisplayingHistoryIboB && (
            <TopicsHistory
              ibo={iboB}
              isCreatingIbo={iboB.isSyncing}
              isShowHistory={false}
              refresh={async (contact) => {
                await refetch(contact);
              }}
              onClose={() => {
                setIsDisplayingHistoryIboB(false);
              }}
              onCancel={handleCancel}
            ></TopicsHistory>
          )}

          {isDisplayingDetailsIboB && (
            <TopicDetails
              refetch={refetch}
              syncTopicsAccount={syncTopicsAccount}
              fetchIboSyncData={fetchIboSyncData}
              data={iboB}
              hideHeader={isDisplayingHistoryIboB}
              retrieveAccessCode={retrieveAccessCode}
              accessCode={accessCodeIboB}
              clearAccessCode={clearAccessCode}
              retrieveGroupUsers={retrieveGroupUsers}
              retrieveThreadUsers={retrieveThreadUsers}
              membership={membership}
              userData={userData}
            />
          )}
        </div>
      )}
    </div>
  );
}
